<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div class="ts-flex ts-space-x-3">
        <!-- keep this section in msk -->
        <!-- <ts-checkbox
            v-model="model.is_dealer_price"
            @change="onDealerPriceChange"
          >
            {{ $t('borrowingSparePart.dealerPrice') }}
          </ts-checkbox> -->
        <!-- end section -->
        <a
          href="#"
          class="ts-shadow-rounded ts-uppercase ts-px-4 ts-rounded-md ts-bg-blue-400 ts-text-white ts-flex ts-items-center ts-no-underline hover:ts-no-underline"
          style="height: 31px"
          @click.prevent="getProductBalance"
        >
          <span class="ts-mr-2">{{ $t('saleContract.getBalance') }}</span>
          <i class="fas fa-balance-scale"></i>
        </a>
      </div>
      <div class="ts-space-x-3 ts-flex ts-uppercase">
        <h6>
          <span
            >{{ $t('borrowingSparePart.fxRateKh') }}:
            {{ $formatNumber(model.fx_rate_kh) }} ៛</span
          >
        </h6>
        <!-- keep this section in msk -->
        <!-- <h6>
            <a href="#" @click.prevent="onMachineryClick">
              <span class="ts-text-blue-600"
                >{{ $t('borrowingSparePart.machinery') }}:
              </span>
              {{ model.product_name }}
            </a>
          </h6>
          <h6>
            <a href="#" @click.prevent="$emit('showSerial')">
              <span class="ts-text-blue-600"
                >{{ $t('borrowingSparePart.engineNumber') }}:
              </span>
              {{ model.engine_number }}
            </a>
          </h6> -->
        <!-- end section -->
      </div>
    </div>
    <div style="max-height: 50vh;" class="ts-overflow-y-scroll">
      <table class="ts-w-full ts-mt-3">
        <thead>
          <tr class="ts-bg-gray-200 ts-border-b">
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-3"
            >
              {{ $t('borrowingSparePart.no') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-24"
            >
              {{ $t('borrowingSparePart.barcode') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase"
            >
              {{ $t('borrowingSparePart.product') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-32 ts-text-center"
            >
              {{ $t('borrowingSparePart.endingBalance') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-48"
            >
              {{ $t('borrowingSparePart.type') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-24"
            >
              {{ $t('borrowingSparePart.uom') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-24 ts-text-center"
            >
              {{ $t('borrowingSparePart.qtyOrder') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-24 ts-text-center"
            >
              {{ $t('borrowingSparePart.overDemand') }}
            </th>
            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-uppercase ts-w-32 ts-text-center"
            >
              {{ $t('borrowingSparePart.overQty') }}
            </th>

            <th
              class="ts-px-3 ts-py-2 ts-sticky ts-top-0 ts-bg-gray-200 ts-w-2"
            >
              <a
                href="#"
                @click.prevent="onClickShowModalProduct"
                v-if="model.location_id"
                ><i class="fas fa-plus"></i
              ></a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="ts-border-b"
            v-for="(p, index) in model.product_detail"
            :key="index"
          >
            <td class="ts-px-3 ts-py-2">{{ index + 1 }}</td>
            <td class="ts-px-3 ts-py-2">{{ p.barcode }}</td>
            <td class="ts-px-3 ts-py-2">{{ p.product_name }}</td>
            <td class="ts-px-3 ts-py-2 ts-text-center">
              {{ p.ending_balance }}
            </td>
            <td class="ts-px-3 ts-py-2">
              <select class="ts-w-full ts-outline-none" v-model="p.type_number">
                <option
                  v-for="(t, index) in materialTypes"
                  :key="index"
                  :value="t.value"
                >
                  {{ t.label }}
                </option>
              </select>
              <div
                class="validate"
                v-if="errors.has('product_detail.' + index + '.type_number')"
              >
                {{ errors.first('product_detail.' + index + '.type_number') }}
              </div>
            </td>
            <td class="ts-px-3 ts-py-2">
              <select
                class="ts-w-full ts-outline-none"
                v-model="p.uom_id"
                @change="onUomChange(p)"
              >
                <option
                  v-for="(u, index) in getUomList(p.product_id)"
                  :key="index"
                  :value="u.uom_id"
                >
                  {{ u.uom_name_en }}
                </option>
              </select>
              <div
                class="validate"
                v-if="errors.has('product_detail.' + index + '.uom_id')"
              >
                {{ errors.first('product_detail.' + index + '.uom_id') }}
              </div>
            </td>
            <td class="ts-px-3 ts-py-2">
              <input
                v-model.number="p.quantity_order"
                type="number"
                value="3"
                class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1 ts-outline-none"
                @input="calculate"
              />
              <div
                class="validate"
                v-if="errors.has('product_detail.' + index + '.quantity_order')"
              >
                {{
                  errors.first('product_detail.' + index + '.quantity_order')
                }}
              </div>
            </td>
            <td class="ts-px-3 ts-py-2 ts-text-center">
              <input type="checkbox" v-model="p.over_demand" />
            </td>
            <td class="ts-px-3 ts-py-2">
              <input
                v-model.number="p.over_demand_qty"
                :readonly="!p.over_demand"
                step="any"
                type="number"
                value="3"
                class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1 ts-outline-none"
              />
            </td>
            <td class="ts-px-3 ts-py-2 ts-text-center">
              <a
                href="#"
                class="ts-text-red-600 ts-my-auto"
                @click.prevent="removeRow(p, index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="ts-w">
            <td
              class="ts-text-red-700 ts-text-right ts-px-3 ts-py-2"
              colspan="6"
            >
              {{ $t('borrowingSparePart.total') + ': ' }}
            </td>
            <td class="ts-text-red-700 ts-text-center ts-px-3 ts-pr-6 ts-py-2">
              {{ $formatNumber(qty) }}
            </td>
            <td
              class="ts-text-red-700  ts-px-3 ts-py-2 ts-pr-5 ts-text-center"
              colspan="2"
            ></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- search product  -->
    <a-modal
      v-model="visible"
      :title="$t('borrowingSparePart.productList')"
      :footer="null"
    >
      <ts-loading-banner :loading="searching">
        <div class="ts-flex">
          <div class="ts-relative ts-w-full">
            <input
              v-model.trim="searchValue"
              ref="search"
              type="text"
              class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
              :placeholder="$t('borrowingSparePart.searchProduct')"
              @keydown.enter="onProductSearch"
            />
            <span
              class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
              style="margin-top: 7px"
            >
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
        <small><i>Press enter to search product.</i></small>
        <div class="container-table">
          <table class="ts-w-full ts-mt-3" v-if="productFromServer.length">
            <tbody>
              <tr
                v-for="(p, index) in productFromServer"
                :key="index"
                class="ts-border-b hover:ts-bg-gray-100 ts-cursor-pointer"
                @click="onAddProduct(p)"
              >
                <td class="ts-py-2">
                  <div style="line-height: 1.25">
                    <p class="ts-mb-0">
                      {{
                        p.product_name_kh
                          ? p.product_name_kh
                          : p.product_name_en
                      }}
                    </p>
                    <p class="ts-mb-0">{{ p.barcode }}</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="ts-h-64 ts-flex ts-items-center ts-justify-center">
            <div class="ts-flex ts-flex-col ts-items-center ts-justify-center">
              <p class="ts-flex ts-items-center ts-justify-center">
                <i class="fas fa-folder-open fa-3x ts-text-gray-400"></i>
              </p>
              <h1 class="ts-text-gray-400 ts-text-sm">No Data Found!</h1>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>

    <!-- show machinery -->
    <a-modal
      v-model="show_machinery"
      :title="$t('borrowingSparePart.machinery')"
      :footer="null"
      width="350px"
    >
      <ts-loading-banner :loading="main_product_searching">
        <div class="ts-w-full ts-space-y-3">
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('borrowingSparePart.product')
              }}</label>
              <a-select
                show-search
                v-model="model.product_id"
                :placeholder="$t('borrowingSparePart.searchProduct')"
                style="width: 300px"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="handleSearch"
                @change="mainProductChange"
              >
                <a-select-option v-for="p in productList" :key="p.product_id">
                  {{ p.product_name_kh }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('borrowingSparePart.engineNumber')
              }}</label>
              <input
                v-model="engine_number"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('engine_number') }"
                @input="inputEngine"
              />
              <div
                class="invalid-feedback ts-text-xs"
                v-if="errors.has('engine_number')"
              >
                {{ errors.first('engine_number') }}
              </div>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce, includes, sumBy } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      searchValue: null,
      visible: false,
      show_machinery: false,
      main_product_searching: false,
      searching: false,
      engine_number: null,
      amount: 0,
      qty: 0,
      model: {},
      tempDetails: []
    }
  },
  created() {
    this.model = this.value
    this.model.fx_rate_kh = parseFloat(
      this.$store.state.authUser.sys_setting.fx_rate
    )
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['formModels']),
    productFromServer() {
      if (!this.formModels.product) return []
      return this.formModels.product.filter(
        p =>
          !includes(
            this.tempDetails.map(el => el.product_id),
            p.product_id
          )
      )
    },
    getUomList: vm => productId => {
      let uomList = vm.tempDetails.find(d => d.product_id == productId)
      return uomList ? uomList.unit_of_measures : []
    },
    productList() {
      return this.formModels.mainProduct
    },
    materialTypes() {
      return [
        {
          value: 1,
          label: 'Stationary'
        },
        {
          value: 2,
          label: 'Materials/Tools/Vehicle'
        }
      ]
    }
  },
  methods: {
    ...mapActions('wholesale/borrowingSparePart', [
      'getFormViewData',
      'productBalance'
    ]),
    onClickShowModalProduct() {
      this.visible = true
      this.onProductSearch()
    },
    async onProductSearch() {
      this.searching = true
      await this.getFormViewData({
        index: 'product',
        params: {
          fnName: 'product',
          search: this.searchValue,
          from_location_id: this.model.location_id
        }
      })
      this.searching = false
    },
    onAddProduct(product) {
      let uomId = product.unit_of_measures.find(u => u.is_default).uom_id
      let price = product.sale_code.find(p => p.uom_id == uomId)
      this.model.product_detail.push({
        product_id: product.product_id,
        barcode: product.barcode,
        product_name: product.product_name_kh
          ? product.product_name_kh
          : product.product_name_en,
        uom_id: uomId,
        quantity_order: 1,
        sale_price: this.model.is_dealer_price
          ? price.dealer_price
          : price.sale_price,
        vendor_standard_price: price.vendor_standard_price,
        discount_rate: 0,
        amount: price.sale_price * 1,
        ending_balance: product.ending_balance,
        is_calculate_stock: product.is_calculate_stock,
        remarks: null,
        type_number: 2,
        over_demand: false,
        over_demand_qty: 0
      })
      this.tempDetails.push(product)
    },
    removeRow(p, index) {
      this.model.product_detail.splice(index, 1)
      this.tempDetails.splice(this.tempDetails.indexOf(p.product_id), 1)
    },
    onUomChange(product) {
      let saleCode = this.tempDetails.find(
        t => t.product_id == product.product_id
      )
      let price = saleCode.find(s => s.uom_id == product.uom_id)
      product.sale_price = this.model.is_dealer_price
        ? price.dealer_price
        : price.sale_price
      this.calculate()
    },
    onDealerPriceChange() {
      this.model.product_detail.forEach(el => {
        let product = this.tempDetails.find(t => t.product_id == el.product_id)
        let price = product.sale_code.find(s => s.uom_id == el.uom_id)
        el.sale_price = this.model.is_dealer_price
          ? price.dealer_price
          : price.sale_price

        var calculatePrice = el.sale_price * el.quantity_order
        var discount_amount = (calculatePrice * el.discount_rate) / 100
        el.amount = calculatePrice - discount_amount
      })
    },
    calculate() {
      this.model.product_detail.forEach(el => {
        var price = el.sale_price * el.quantity_order
        var discount_amount = (price * el.discount_rate) / 100
        el.amount = price - discount_amount
      })
    },
    onMachineryClick: debounce(async function() {
      this.show_machinery = true
      if (this.model.product_id) {
        this.main_product_searching = true
        await this.getFormViewData({
          index: 'mainProduct',
          params: {
            product_id: this.model.product_id
          }
        })
      }
      this.main_product_searching = false
    }, 800),
    handleSearch: debounce(async function(value) {
      this.main_product_searching = true
      await this.getFormViewData({
        index: 'mainProduct',
        params: {
          fnName: 'mainProduct',
          search_product: value
        }
      })
      this.main_product_searching = false
    }, 800),
    mainProductChange(value) {
      this.model.product_name = this.productList.find(
        p => p.product_id == value
      ).product_name_kh
    },
    inputEngine() {
      this.model.engine_number = this.engine_number
    },
    amountTotal() {
      this.amount =
        sumBy(this.model.product_detail, function(o) {
          return o.amount
        }) * this.model.fx_rate_kh
    },
    sumTotalQty() {
      this.qty = sumBy(this.model.product_detail, 'quantity_order')
    },
    getProductBalance() {
      // this.$emit('loading', true)
      var product = this.model.product_detail.map(el => el.product_id)
      if (product.length) {
        this.$emit('loading', true)
        this.productBalance({
          product_id: product
        })
          .then(response => {
            let data = response.data
            this.model.product_detail.forEach(el => {
              const findingBalance = data.find(
                p => p.product_id == el.product_id
              )

              if (findingBalance != undefined) {
                el.ending_balance = findingBalance.ending_balance
              }
            })
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      }
    }
  },
  watch: {
    'model.product_detail': {
      handler() {
        this.amountTotal()
        this.sumTotalQty()
      },
      deep: true
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.container-table {
  min-height: 400px;
  max-height: 450px;
  overflow-y: scroll;
}
</style>
